<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table">
        <slot></slot>
      </h3>
      <div style="display: flex; align-items: center; gap: 10px">
        <div class="ly-sort ly-sort-his">
          <!-- 접수의견일 경우만 보고서 뷰어 버튼이 보이도록 -->
          <span v-if="stepCd == 2865">
            <el-button type="primary" size="small"      
              plain
              @click="showOzViewer"
            >
              작업의견출력
            </el-button>
          </span>
        </div>
        <div class="table-toggle" v-if="toggle === true">
          <i class="el-icon-arrow-up" @click="clickToggle"></i>
        </div>
      </div>
    </div>
    <div ref="content">
      <div class="editor-box">
        <idc-editor
          ref="editor"
          :editorHtmlContent="this.form.data.sbst"
          @getEditorContent="getEditorContent"
          :isWrite="isWrite"
          type="wrk"
        />
      </div>
      <div class="btn-box" v-if="this.isWrite || !this.isTemplate && !$isMobile()">
        <el-button  type="primary" size="medium" @click="onSave" v-if="isWrite"
          :disabled="isTemplate">{{ $t("messages.btnSave") }}</el-button>
      </div>
      <el-button type="primary" size="medium" v-if="hasButton"
        ><!-- 22.03.14 누락사항 반영 -->
        {{ $t("messages.btnSave") }}</el-button
      >
    </div>
    <el-divider class="wrk-comp-divider" v-if="!toggleData"></el-divider>
  </div>
</template>

<script>
import IdcEditor from "@/components/wrkManageComponents/commonComponents/IdcEditor.vue";
import { copyObject } from '@/assets/js/common.js';
export default {
  components: {
    IdcEditor,
  },
  props: {
    hasButton: {
      // 22.03.14 누락사항 반영
      value: Boolean,
      dafault: false,
    },

    // -----------------------------------------------
    openToggle: {
      value: Boolean,
      dafault: false,
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    idcCd: {
      type: String,
      default: "",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    stepCd: {
      type: Number,
      default: 0,
    },
    //상위 공정 ID
    mainPrcssId: {
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    scrnId: {
      type: String,
      default: "",
    },
    mandDataChkYn: {
      //필수데이터
      type: String,
      default: "",
    },
    sftyChkMandChkYn: {
      //안전점검 필수여부 > skip할 경우 true
      type: String,
      default: "",
    },
    sftyChkScrnYn: {
      //안전관리 화면YN
      type: String,
      default: "",
    },
    scrnGetApi: {
      type: String,
      default: "",
    },
    scrnPostApi: {
      type: String,
      default: "",
    },
    scrnPutApi: {
      type: String,
      default: "",
    },
    scrnDeleteApi: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      toggleData: true,
      toggle: this.openToggle,
      form: {
        data: {},
      },
      currPrcssTrtDataCnctId: "",
      chkData:"",
    };
  },
  mounted() {
    // 의견 정보 조회
    this.getWrkComnSbst(true);
  },
  watch: {
    isWrite(){
      this.$refs.editor.setOptions({ editable : this.isWrite }); 
    },
    prcssTrtDataCnctId() {
      this.getWrkComnSbst(true);
    },
  },
  computed: {
  },
  methods: {
    clickToggle(e) {
      if (this.toggleData) {
        this.$refs.content.style = "display: none";
        e.target.className = "el-icon-arrow-down";
      } else {
        this.$refs.content.style = "display: block;";
        e.target.className = "el-icon-arrow-up";
      }
      this.toggleData = this.toggleData ? false : true;
    },
    //조회
    async getWrkComnSbst(initFlag) {
      if (initFlag) {
        if (this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != "") {
          this.currPrcssTrtDataCnctId = this.prcssTrtDataCnctId;
        } else {
          // 기본값 설정
          if (this.defaultValue && Object.keys(this.defaultValue).length > 0 && this.isWrite) {
            //console.log('기본값 데이터')
            //console.log(this.defaultValue.sbst)
            this.form.data.sbst = this.defaultValue.sbst;
            this.form = copyObject(this.form);
          }
          return;
        }
      }

      const data = await this.$BIZ_SERVICE.post(this.scrnGetApi, {
        prcssTrtDataCnctId: this.currPrcssTrtDataCnctId,
      });

      if (data.data.resData) {
        this.form.data = data.data.resData;
        this.chkData = data.data.resData.sbst;
      }
    },
    //데이터 삽입
    setReqData(){
      this.form.data.exeWflowId  = this.exeWflowId
      this.form.data.prcssId     = this.subPrcssId
      this.form.data.stepCd      = this.stepCd
      this.form.data.scrnId      = this.scrnId
      // this.form.data.trtrId       = this.ticketInfo.trtrId // TODO 스케줄에서 조회 시 오류나서 임시 막음
      this.form.data.ticktId     = (this.ticketInfo ? this.ticketInfo.ticktId : null)
      this.form.data.mainPrcssId = this.mainPrcssId
      this.form.data.subPrcssId  = this.subPrcssId
      this.form.data.prcssTrtDataCnctId = this.currPrcssTrtDataCnctId
      this.form.data.wflowScrnId = this.wflowScrnId
    },
    //저장
    onSave() {
      this.setReqData();
      
      this.$BIZ_SERVICE.post(this.scrnPostApi, this.form.data)

      .then(async(res) => {
        //저장 성공 후 공정처리연결ID 재매핑
        this.currPrcssTrtDataCnctId = res.data.resData
        //공정처리데이터연결아이디 재조회
        await this.$store.dispatch("wflowStore/geteWflowPrcssTrtDataCnctList", {
          exeWflowId: this.exeWflowId,
          stepCd: Number(this.stepCd),
        });
        alert("등록되었습니다.");

        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getWrkComnSbst(false);
        });
    },
    getEditorContent(text) {
      this.form.data.sbst = text;
    },
    getTemplateData() {
      this.setReqData();
      return this.form.data;
    },
    chkValidateData() {
      // 공정처리데이터아이디가 있으면 true
      // 단, 목록성 데이터인 경우 로우가 있어야지 true
      console.log('체크')
      if (this.mandDataChkYn != 'Y') {
        return true;
      } else {
        if (this.currPrcssTrtDataCnctId != null && this.currPrcssTrtDataCnctId != '') {
          if (this.chkData != this.form.data.sbst) return false; 
          if (this.form.data.sbst) return true;
        }else{
          if(!this.chkData) return false;
        }
      }
    },
    showOzViewer() {
      if(this.prcssTrtDataCnctId == null || this.prcssTrtDataCnctId == '') {
        alert('접수의견이 없습니다.');
        return false;
      }

      let _width = "1000";
      let _height = "984";
      let xPos = document.body.offsetWidth / 2 - _width / 2; // 가운데 정렬
      xPos += window.screenLeft; // 듀얼 모니터일 때
      let yPos = document.body.offsetHeight / 2 - _height / 2;

      this.myWindow = window.open(
        this.$reporHostUrl +
        "/ossapi/report/getOzWrkComnSbst?id=" + this.prcssTrtDataCnctId,
        "myWindow",
        "width=" +
          _width +
          ",height=" +
          _height +
          ", left=" +
          xPos +
          ", top=" +
          yPos
      );
    }
  },
};
</script>
<style lang="scss" scoped>
.btn-box {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.el-button {
  // 22.03.14 누락사항 반영
  margin-top: 20px;
  // height: 50px;
}
@include mobile {
  .ly-table {
    padding-top: 20px !important;
  }
  .el-button {
    margin-top: 20px;
    // height: 50px;
  }
}
</style>
